import "./Contactfromstyles.css"

function ContactForm() {
    return( 
        
        <div className="form-container">
            <div className="location">

            <h2>Find us</h2>
                <p>
                TRV Towers 8th floor <br></br>Lower MuseumHill Nairobi <br></br><br></br>
                info@multishadeinsurance.com
                <br></br><br></br>
                Tel: +254 727 972 901
                <br></br><br></br>
                OPENING HOURS<br></br>
                Mon-Fri : 8am - 5pm<br></br>
                Saturday: 9am - 1pm<br></br>
                Sunday: closed<br></br>
                Holidays: closed

                </p>
                
            </div>
            <form>
                <input placeholder="Name"/>
                <input placeholder="Email"/>
                <input placeholder="Subject"/>
                <textarea placeholder="Message" rows="7" className="textarea"></textarea>
                <button>Send Message</button>
            </form>
        </div>
    )
    
    
}

export default ContactForm;
